import produce from "immer";
import { defaultFilters } from "../../Data/cardFilters";
import {
  blogFilters,
  enqFilters,
  invFilters,
  newsFilters,
  resFilters,
  revFilters,
  surveyFilters,
  employeeFilters,
  webEmpFilters,
} from "../../Data/filters";
import { defaultFilters as posterDefFilters } from "../../Data/posterFilters";
import { defaultFilters as qrDefFilters } from "../../Data/surveyPosterFilters";

import {
  RESET_ENQ_FILTERS,
  // BLOG
  SET_BLOG_FETCHER,
  SET_BLOG_FILTERS,
  SET_CARD_FILTERS,
  SET_CARD_VIEW,
  SET_DASHBOARD_FILTERS,
  // ENQUIRY
  SET_ENQ_FETCHER,
  SET_ENQ_FILTERS,
  SET_HEADLINE_FILTERS,
  //
  SET_INV_FETCHER,
  SET_INV_FILTERS,
  // NEWS
  SET_NEWS_FETCHER,
  SET_NEWS_FILTERS,
  //
  SET_OVERVIEW_FILTERS,
  SET_POSTER_FILTERS,
  //
  SET_QR_FILTERS,
  SET_REPORT_FILTERS,
  //
  SET_RES_FETCHER,
  SET_RES_FILTERS,
  // REVIEW
  SET_REV_FETCHER,
  SET_REV_FILTERS,
  SET_SURVEY_DATA,
  //
  SET_SURVEY_FETCHER,
  SET_SURVEY_FILTERS,
  //
  SET_EMP_FETCHER,
  SET_EMP_FILTERS,
  //
  SET_WEBENQ_FETCHER,
  SET_WEBENQ_FILTERS,
} from "./constants";

export const initialState = {
  cardFilters: { ...defaultFilters },
  posterFilters: { ...posterDefFilters },
  cardView: "Front View",
  //
  blogFetcher: false,
  blogFilters: { ...blogFilters },
  //
  newsFetcher: false,
  newsFilters: { ...newsFilters },
  //
  enqFetcher: false,
  enqFilters: { ...enqFilters },
  //
  revFetcher: false,
  revFilters: { ...revFilters },
  //
  qrFilters: { ...qrDefFilters },
  //
  invFetcher: false,
  invFilters: { ...invFilters },
  //
  resFetcher: false,
  resFilters: { ...resFilters },
  //
  overviewFilters: {
    year: `${new Date().getFullYear()}`,
    survey: {},
  },
  headlineFilters: {
    year: `${new Date().getFullYear()}`,
    survey: {},
  },
  dashboardFilters: {
    year: `${new Date().getFullYear()}`,
    survey: {},
  },
  //
  surveyFetcher: false,
  surveyFilters: { ...surveyFilters },
  //
  surveyData: {
    name: "",
    offer_text: "",
    description: "",
    type: "",
    status: "",
    start_date: "",
    end_date: "",
    config_type: "",
    template_option: "",
  },
  //
  empFetcher: false,
  empFilters: { ...employeeFilters },
  //
  WebEnqFetcher: false,
  WebEnqFilters: { ...webEmpFilters },
};

const FilterReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case SET_CARD_FILTERS:
        draft.cardFilters = action.payload;
        break;

      case SET_POSTER_FILTERS:
        draft.posterFilters = action.payload;
        break;

      case SET_CARD_VIEW:
        draft.cardView = action.payload;
        break;

      case SET_BLOG_FETCHER:
        draft.blogFetcher = action.payload;
        break;
      case SET_BLOG_FILTERS:
        draft.blogFilters = action.payload;
        break;

      case SET_NEWS_FETCHER:
        draft.newsFetcher = action.payload;
        break;
      case SET_NEWS_FILTERS:
        draft.newsFilters = action.payload;
        break;

      case SET_ENQ_FETCHER:
        draft.enqFetcher = action.payload;
        break;
      case SET_ENQ_FILTERS:
        draft.enqFilters = action.payload;
        break;

      case SET_REV_FETCHER:
        draft.revFetcher = action.payload;
        break;
      case SET_REV_FILTERS:
        draft.revFilters = action.payload;
        break;

      case SET_QR_FILTERS:
        draft.qrFilters = action.payload;
        break;

      case SET_INV_FETCHER:
        draft.invFetcher = action.payload;
        break;
      case SET_INV_FILTERS:
        draft.invFilters = action.payload;
        break;

      case SET_RES_FETCHER:
        draft.resFetcher = action.payload;
        break;
      case SET_RES_FILTERS:
        draft.resFilters = action.payload;
        break;

      case SET_OVERVIEW_FILTERS:
        draft.overviewFilters = action.payload;
        break;

      case SET_HEADLINE_FILTERS:
        draft.headlineFilters = action.payload;
        break;

      case SET_DASHBOARD_FILTERS:
        draft.dashboardFilters = action.payload;
        break;

      case SET_SURVEY_FETCHER:
        draft.surveyFetcher = action.payload;
        break;
      case SET_SURVEY_FILTERS:
        draft.surveyFilters = action.payload;
        break;

      case RESET_ENQ_FILTERS:
        draft.dashboardFilters = {
          year: `${new Date().getFullYear()}`,
          survey: {},
        };
        draft.overviewFilters = {
          year: `${new Date().getFullYear()}`,
          survey: {},
        };
        draft.headlineFilters = {
          year: `${new Date().getFullYear()}`,
          survey: {},
        };
        break;

      case SET_REPORT_FILTERS:
        draft.dashboardFilters = action.payload;
        draft.overviewFilters = action.payload;
        draft.headlineFilters = action.payload;
        break;

      case SET_SURVEY_DATA:
        draft.surveyData = action.payload;
        break;

      case SET_EMP_FETCHER:
        draft.empFetcher = action.payload;
        break;
      case SET_EMP_FILTERS:
        draft.empFilters = action.payload;
        break;

      case SET_WEBENQ_FETCHER:
        draft.WebEnqFetcher = action.payload;
        break;
      case SET_WEBENQ_FILTERS:
        draft.WebEnqFilters = action.payload;
        break;

      default:
        return state;
    }
  });

export default FilterReducer;
